var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9984 0C20.1759 0 26.0032 5.83588 26 13.0206C25.9968 20.2165 20.0718 26.1261 12.7549 25.998C5.81444 25.8762 0.00320487 20.2005 1.31698e-06 12.9934C-0.00320223 5.82948 5.83847 0 12.9984 0ZM13.2459 1.87507C13.2454 1.87456 13.2447 1.87426 13.2439 1.87424C7.34347 1.70346 2.09991 6.40176 1.87248 12.6041C1.65303 18.6114 6.30939 23.7969 12.425 24.1253C18.563 24.4537 23.8312 19.6895 24.1291 13.53C24.4334 7.22516 19.4029 1.98226 13.2478 1.8759C13.2471 1.87588 13.2464 1.87559 13.2459 1.87507Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9982 16.203C11.9979 16.2034 11.9973 16.2033 11.9972 16.2028C11.7961 14.725 12.5205 13.5878 13.5604 12.5689C14.14 12.0008 14.7542 11.46 15.3045 10.8695C16.2757 9.82942 16.1464 8.52212 15.0267 7.60524C14.0658 6.81957 12.9738 6.63396 11.8059 7.0884C10.6432 7.54123 10.0532 8.40371 9.99625 9.575C9.96864 10.1367 9.52356 10.5415 8.96116 10.5207C8.39532 10.4999 7.98819 10.071 8.00026 9.5062C8.05202 6.76197 10.7898 4.62739 13.707 5.05463C16.1653 5.41466 17.944 7.28681 17.9992 9.5606C18.0181 10.3527 17.7162 11.0487 17.1901 11.6408C16.5949 12.3096 15.9204 12.9177 15.301 13.5673C14.9301 13.9562 14.5592 14.353 14.2591 14.7882C14.0952 15.0251 14.0331 15.3467 14.0089 15.6363C13.9692 16.0971 14.002 16.5628 13.9968 17.0268C13.9917 17.5773 13.5776 17.9885 13.0256 17.9997C12.4632 18.0125 12.0216 17.6045 12.0009 17.0412C11.9905 16.7619 11.9991 16.4825 11.9991 16.2032C11.9991 16.2027 11.9984 16.2025 11.9982 16.203Z",
    fill: "#FFA900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.9965 22C12.447 21.9977 11.9989 21.5499 12 21.0029C12 20.4582 12.4528 20.0035 12.9965 20C13.5483 19.9954 14.0057 20.457 13.9999 21.0133C13.9953 21.5649 13.5506 22.0023 12.9965 22Z",
    fill: "#FFA900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionicon);
export default __webpack_public_path__ + "static/media/questionicon.dd2c83558f295816fef749d6adb23444.svg";
export { ForwardRef as ReactComponent };